module.exports = __webpack_public_path__ + "static/media/iceberg.921419e0.svg";